import type { IconProps } from "../types";

export const FolderPlus = ({
  size = 24,
  strokeWidth = 2,
  absoluteStrokeWidth,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="butt"
    strokeLinejoin="miter"
    {...props}
  >
    <path d="M12 10v6" />
    <path d="M9 13h6" />
    <path d="M22 20V6H11.02L8.99 3H2V20Z" />
  </svg>
);
